<ng-container>
  <mat-icon>{{ icon }}</mat-icon>
  <ng-content></ng-content>
</ng-container>
